module.exports = __webpack_public_path__ + "static/media/nielit.c8435339.png";